/* import __COLOCATED_TEMPLATE__ from './custom-select.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();